import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

interface IUserResponse {
  message: string;
  payload: IUser;
}

interface IUser {
  id: string;
  email: string;
  username: string;
  fullName: string;
  gender: string;
  phoneNumber: string;
  nationalIdNumber: string;
  organizationId?: string;
  profilePictureUrl?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private api: ApiService) {}

  getMe(): Observable<IUserResponse> {
    return this.api.GET<IUserResponse>('users/me');
  }

  changePassword(payload: {
    "oldPassword": "string",
    "newPassword": "string"
  }): Observable<IUserResponse> {
    return this.api.PATCH<IUserResponse>('users/change-password', payload);
  }

  updateUser(payload: {
    profilePicture?: File | null;
    email?: string;
    phoneNumber?: string;
  }): Observable<IUserResponse> {
    const formData = new FormData();
    if (payload.profilePicture) {
      formData.append('profilePicture', payload.profilePicture);
    }
    if (payload.email) {
      formData.append('email', payload.email);
    }
    if (payload.phoneNumber) {
      formData.append('phoneNumber', payload.phoneNumber);
    }
    return this.api.PATCH<IUserResponse>('users/me', formData);
  }
}
